/** @jsxImportSource @emotion/react */
import { LandingPage } from "../components/homepage/LandingPage";


export function Home() {

    return (
        <section>
            <LandingPage />
        </section>
    )
}
